import { render, staticRenderFns } from "./QuestionCheckbox.vue?vue&type=template&id=5a89290a&scoped=true"
import script from "./QuestionCheckbox.vue?vue&type=script&lang=js"
export * from "./QuestionCheckbox.vue?vue&type=script&lang=js"
import style0 from "./QuestionCheckbox.vue?vue&type=style&index=0&id=5a89290a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a89290a",
  null
  
)

export default component.exports